import type { HTMLAttributes } from 'react';

import { cn } from './cn';

export function Skeleton({ className, ...rest }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      aria-hidden="true"
      className={cn('animate-pulse rounded-2xl bg-cream-200', className)}
      {...rest}
    />
  );
}
